import { BtnFollowGoogle } from "./styles";
import ContentIcon from "@/shared/ContentIcon";

const GOOGLE_ICON_SRC = "/img/IconGoogle.svg";

const FollowGoogle = ({
  className = "",
  href = "https://profile.google.com/cp/CgkvbS8wNzlsOHc?pf=1",

  icon = false,
  iconGoogle = false,
  logoGoogle = false,

  text,
  subText,
}) => {
  const showGoogleIcon = iconGoogle || logoGoogle;
  const hasBtnIcon = icon;
  const isOnlyGoogleIcon = showGoogleIcon && !hasBtnIcon;

  return (
    <BtnFollowGoogle
      href={href}
      className={`
        ${className}
        ${isOnlyGoogleIcon ? "has-only-google-icon" : ""}
    `}
      target="_blank"
      rel="noopener noreferrer"
    >
      {icon && (
        <span className="follow-google__icon">
          <ContentIcon width="15px" height="15px" nameIcon="plus-solid" />
        </span>
      )}

      {(text || showGoogleIcon) && (
        <span className="follow-google__content">
          {text && (
            <span className="follow-google__text" aria-hidden="true">
              {text}
            </span>
          )}

          {showGoogleIcon && (
            <img
              src={GOOGLE_ICON_SRC}
              alt="Google"
              className="btn img__icon-google"
            />
          )}
        </span>
      )}
    </BtnFollowGoogle>
  );
};

export default FollowGoogle;
